import type { HydrateAction } from '@/domains/core/applicationState/store/hydrateAction';
import type { EligibilityCoupon } from '@/domains/loyalty/modules/CouponEligibility/interfaces/EligibilityCoupon';
import { GraphqlSuccess } from '@/productDiscovery/ProductPage/detail.actions';

export const GET_ELIGIBILITY_COUPON_REQUEST =
  'eligibilityCoupon/GET_ELIGIBILITY_COUPON_REQUEST';
export const GET_ELIGIBILITY_COUPON_SUCCESS =
  'eligibilityCoupon/GET_ELIGIBILITY_COUPON_SUCCESS';
export const GET_ELIGIBILITY_COUPON_FAILED =
  'eligibilityCoupon/GET_ELIGIBILITY_COUPON_FAILED';

export interface GetEligibilityCouponRequestAction {
  type: typeof GET_ELIGIBILITY_COUPON_REQUEST;
}

export const getEligibilityCoupon = (): GetEligibilityCouponRequestAction => ({
  type: GET_ELIGIBILITY_COUPON_REQUEST,
});

export interface GetEligibilityCouponSuccessAction {
  type: typeof GET_ELIGIBILITY_COUPON_SUCCESS;
  payload: EligibilityCoupon | null;
}

export const getEligibilityCouponSuccess = (
  eligibilityCoupon: EligibilityCoupon | null,
): GetEligibilityCouponSuccessAction => ({
  type: GET_ELIGIBILITY_COUPON_SUCCESS,
  payload: eligibilityCoupon,
});

export interface GetEligibilityCouponFailedAction {
  type: typeof GET_ELIGIBILITY_COUPON_FAILED;
  error: string;
}

export const getEligibilityCouponFailed = (
  error: string,
): GetEligibilityCouponFailedAction => ({
  type: GET_ELIGIBILITY_COUPON_FAILED,
  error,
});

export type GetEligibilityCouponActions =
  | GetEligibilityCouponRequestAction
  | GetEligibilityCouponSuccessAction
  | GetEligibilityCouponFailedAction
  | GraphqlSuccess
  | HydrateAction;
